/*
 *
 * Header constants
 *
 */

export const DEFAULT_ACTION = 'app/Header/DEFAULT_ACTION';
export const UPDATE_CLIENT_NAME = 'app/Header/UPDATE_CLIENT_NAME';
export const UPDATE_CLIENT_IP = 'app/Header/UPDATE_CLIENT_IP';
